import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { ResearchAssistantSocketProvider } from '@verantos-dev/feature-research-assistant';

import { CohortBuilderLoadingTemplate } from '../components/CohortBuilderLoadingTemplate/CohortBuilderLoadingTemplate';
import { CohortBuilderPageContent as CohortBuilderPageContentV0 } from '../containers/v0/cohort-builder-page-layout/CohortBuilderPageContent/CohortBuilderPageContent';
import { CohortBuilderPageHeader as CohortBuilderPageHeaderV0 } from '../containers/v0/cohort-builder-page-layout/CohortBuilderPageHeader/CohortBuilderPageHeader';
import { CohortBuilderModalProvider } from '../contexts/CohortBuilderModalContext';
import { useResetCohortBuilderState } from '../hooks/common/useResetCohortBuilderState';
import { useCohortBuilderPage } from '../hooks/useCohortBuilderPage';

export const CohortBuilderPageWrapper = () => {
  /** This code block resets state prior to entering into the cohort builder
   *  to ensure it is always refreshed with the latest */
  const { resetCohortBuilderState } = useResetCohortBuilderState();
  const [reset, setReset] = useState(true);
  // clear state on initial load
  useEffect(() => {
    reset && resetCohortBuilderState();
    setReset(false);
  }, [reset, resetCohortBuilderState]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (reset) return <></>;

  return (
    <ResearchAssistantSocketProvider>
      <CohortBuilderPage />
    </ResearchAssistantSocketProvider>
  );
};

const CohortBuilderPage = () => {
  const { isCohortProfileLoading, cohortDslVersion, isFinalFetchTimerActive } =
    useCohortBuilderPage();

  if (isCohortProfileLoading) {
    return <CohortBuilderLoadingTemplate />;
  }

  if (cohortDslVersion === 0) {
    return (
      <CohortBuilderModalProvider>
        <Box>
          <CohortBuilderPageHeaderV0 />
          <CohortBuilderPageContentV0 isFinalFetchTimerActive={isFinalFetchTimerActive} />
          {/* <ResearchAssistant /> */}
        </Box>
      </CohortBuilderModalProvider>
    );
  }
  // Unknown cohort version
  return <>Unknown cohort version</>;
};
